export const navigationHeight = 68;
